export const InvoiceField = {
  InvoiceSerial: "invoiceSerial",
  InvoiceDate: "invoiceDate",
  invoiceNumber: "invoiceNumber",
  CurrencyId: "currencyId",
  CurrencyCode: "currencyCode",
  exchangeRate: "exchangeRate",
  BuyerTaxCode: "buyerTaxCode",
  BuyerId: "buyerId",
  BuyerCode: "buyerCode",
  BuyerLegalName: "buyerLegalName",
  BuyerAddress: "buyerAddress",
  buyerEmail: "buyerEmail",
  buyerBankAccount: "buyerBankAccount",
  buyerBankName: "buyerBankName",
  buyerDisplayName: "buyerDisplayName",
  buyerTel: "buyerTel",
  OrdinalNumber: "ordinalNumber",
  orders: "orders",
  ProductId: "productId",
  ProductName: "productName",
  ProductCode: "productCode",
  quantity: "quantity",
  UnitPrice: "unitPrice",
  VATRate: "vATRate",
  vATCode: "vatCode",
  vATId: "vATId",
  UnitCode: "unitCode",
  sellerTaxCode: "sellerTaxCode",
  sellerLegalName: "sellerLegalName",
  sellerAddress: "sellerAddress",
  sellerEmail: "sellerEmail",
  sellerTel: "sellerTel",
  sellBankAccount: "sellBankAccount",
  sellerBankName: "sellerBankName",
  sellerFax: "sellerFax",
  sellerWebsite: "sellerWebsite",
  property: "property",
  assetType: "assetType",
  assetCondition: "assetCondition",
  vehicleOrigin: "vehicleOrigin",
  productIdentifier: "productIdentifier",
  safetyEnvCertNo: "safetyEnvCertNo",
  factoryQCSerialNo: "factoryQCSerialNo",
  manufacturingCountryCode: "manufacturingCountryCode",
  yearProduce: "yearProduce",
  registeredAssetTypeCode: "registeredAssetTypeCode",
  registeredAssetTypeName: "registeredAssetTypeName",
  brandCode: "brandCode",
  brandName: "brandName",
  vehicleModelCode: "vehicleModelCode",
  vehicleModel: "vehicleModel",
  engineCapacityOrPower: "engineCapacityOrPower",
  payloadCapacity: "payloadCapacity",
  seatingCapacity: "seatingCapacity",
  assetQualityPercentage: "assetQualityPercentage",
  vehicleLicensePlateNumber: "vehicleLicensePlateNumber",
  totalAmount: "totalAmount",
  totalAmountToWord: "totalAmountToWord",
  paymentMethod: "paymentMethod",
  unitCode: "unitCode",
  relatedTemplateCode: "relatedTemplateCode",
  relatedInvoiceSerial: "relatedInvoiceSerial",
  relatedInvoiceDate: "relatedInvoiceDate",
  relatedInvoiceNumber: "relatedInvoiceNumber",
  relatedInvoiceProperty: "relatedInvoiceProperty",
  relatedInvoiceType: "relatedInvoiceType",
  relatedInvoiceId: "relatedInvoiceId",
  templateCode: "templateCode",
  nonTaxZone: "nonTaxZone",
  isDeductionNQ43: "isDeductionNQ43",
  vatRateOverRevenue: "vatRateOverRevenue",
  totalVATDeduction: "totalVATDeduction",
  isHiddenReport: "isHiddenReport",
  invoiceListId: "invoiceListId",
  invoiceListNumber: "invoiceListNumber",
  invoiceListDate: "invoiceListDate",
  relatedInvoiceIds: "relatedInvoiceIds",
  buyerIdentityCard: "buyerIdentityCard",
  buyerBudgetUnitCode: "buyerBudgetUnitCode",
  // Tách mã tỉnh và mã xã để danh mục hiển thị tên nhưng payload chỉ gửi code.
  provinceCode: "provinceCode",
  wardCode: "wardCode",
  businessLocationAddress: "businessLocationAddress",
  businessLocationCode: "businessLocationCode",
  businessLocationName: "businessLocationName",
};

// Các field này đã bị loại khỏi bộ thông tin 01/BTS nên không được dựng cột hoặc đưa vào payload mới.
export const INVOICE_DETAIL_REMOVED_FIELDS = [
  InvoiceField.registeredAssetTypeCode,
  InvoiceField.brandCode,
  InvoiceField.vehicleModelCode,
  InvoiceField.assetQualityPercentage,
];
